import Person from './Person.js'

class Client extends Person {
  resetMomerizedComputed(){
    this._status = undefined
    this._start_up_date = undefined
  }
  /*  
    This method returns the status of the person
    IMPORTANT:
    This method is reflected in the backend (person.rb) which means any change made to this frontend method must
    be made to the backend method as well.
    This is done to keep the reactivity in the frontend without calling the backend each time a change is made.
  */
  get status(){
    if(this._status){
      return this._status
    } else {
      // The reflected method on the backend is indentical from here
      let s
      if(this.deceased || this.finished_at || (this.entities.length > 0 && this.entities.every(ent => ent.to))){
        s='afsluttet'
      } else if(this.entities.length === 0){
        s='potentiel'
      } else {
        s='aktiv'
      }
      // to here
      return this._status = s
    }
  }
  get start_up_date(){
    if(this._start_up_date){return this._start_up_date}
    return this._start_up_date = this.entities.map(ent => ent.from).sort()[0]
  }
}

export default Client
